import { render } from "./RefundPolicy.vue?vue&type=template&id=5c52797e&scoped=true"
import script from "./RefundPolicy.vue?vue&type=script&lang=js"
export * from "./RefundPolicy.vue?vue&type=script&lang=js"

import "./RefundPolicy.vue?vue&type=style&index=0&id=5c52797e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c52797e"]])

export default __exports__